// extracted by mini-css-extract-plugin
module.exports = {"Logo":"Logo_Logo__Oj5AV","link":"Logo_link__Pb5yt"};